import { faSearch } from '@fortawesome/pro-regular-svg-icons'
import { ActionIcon, Box, Loader, TextInput } from '@mantine/core'
import { getHotkeyHandler, useClickOutside } from '@mantine/hooks'
import { useRouter } from 'next/router'
import { useCallback, useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { Icon, useMediaQuery } from '@flecto/ui'

import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import styles from './styles.module.css'

export function Search() {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })
  const { isDesktop } = useMediaQuery()

  const ref = useClickOutside(() => setOpened(false))
  const path = useStorePathBuilder()
  const router = useRouter()

  const [opened, setOpened] = useState(false)
  const [isRedirecting, setIsRedirecting] = useState(false)
  const [term, setTerm] = useState(
    decodeURI((router.query.q as string) ?? '') ?? ''
  )
  const handleSearchRedirect = () => {
    if (!router.pathname.includes('/search')) {
      setIsRedirecting(true)
    }

    router.push(path(`/search?term=${encodeURI(term)}`))
  }

  const handleShowInputSearchMobile = useCallback(() => {
    setOpened(true)
  }, [ref])

  return (
    <Box className={styles.search}>
      {isDesktop || opened ? (
        <TextInput
          ref={ref}
          rightSection={
            isRedirecting ? (
              <Loader size='xs' />
            ) : (
              <Icon icon={faSearch} color='gray.6' />
            )
          }
          autoFocus={!isDesktop}
          className={styles.searchInput}
          placeholder={
            isDesktop
              ? t('header.search_placeholder')
              : t('header.search_placeholder_mobile')
          }
          radius={100}
          value={term}
          size={isDesktop ? 'md' : 'sm'}
          onChange={(e) => setTerm(e.target.value)}
          onKeyUp={getHotkeyHandler([['Enter', () => handleSearchRedirect()]])}
        />
      ) : (
        <ActionIcon
          variant='light'
          size='sm'
          onClick={handleShowInputSearchMobile}
        >
          <Icon icon={faSearch} color='gray.6' />
        </ActionIcon>
      )}
    </Box>
  )
}
